import makeStyles from '@mui/styles/makeStyles';
import {get} from "lodash";
import React from "react";
import {useTranslation} from "react-i18next";
import {sessionCardStates, curriculumSessionState} from "business/curriculumSession";
import {orderByTheme} from "business/curriculumTheme";
import SectionLinkHeader from "./SectionLinkHeader";
import SessionCard from "./SessionCard";

const PREVIEW_COUNT = 3;

const useStyles = makeStyles({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
    columnGap: 16,
    rowGap: 20,
    alignItems: 'stretch',
  },
});

// A curriculum with sessions attached directly has no milestones to step
// through, so the home shows the first few session cards instead.
const CurriculumSessionsPreview = ({
  sessionStatuses = [],
  selfPicture,
  onOpenSession,
  viewAllTo = '/mentorship/milestones',
}) => {
  const classes = useStyles();
  const {t} = useTranslation();

  // Finished sessions are dropped: the home only needs what is still pending,
  // in the order the curriculum defines.
  const pending = orderByTheme(sessionStatuses).filter(
    sessionStatus =>
      curriculumSessionState(sessionStatus).card !== sessionCardStates.COMPLETED
  );

  if (!pending.length) {
    return null;
  }

  return (
    <div className={classes.wrapper}>
      <SectionLinkHeader label={t('curriculumSessions')} to={viewAllTo}/>
      <div className={classes.grid}>
        {pending.slice(0, PREVIEW_COUNT).map(sessionStatus => (
          <SessionCard
            key={get(sessionStatus, 'session.id')}
            compact
            sessionStatus={sessionStatus}
            selfPicture={selfPicture}
            onOpen={() => onOpenSession(sessionStatus)}
          />
        ))}
      </div>
    </div>
  );
};

export default CurriculumSessionsPreview;
